var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVictory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#30B0C7",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 32C28.1217 32 30.1566 31.1571 31.6569 29.6569C33.1571 28.1566 34 26.1217 34 24C34 21.8783 33.1571 19.8434 31.6569 18.3431C30.1566 16.8429 28.1217 16 26 16C23.8783 16 21.8434 16.8429 20.3431 18.3431C18.8429 19.8434 18 21.8783 18 24C18 26.1217 18.8429 28.1566 20.3431 29.6569C21.8434 31.1571 23.8783 32 26 32ZM23.1438 35C16.9875 35 12 39.9875 12 46.1437C12 47.1687 12.8313 48 13.8563 48H38.1437C38.2562 48 38.3625 47.9875 38.475 47.9688C33.7062 44.525 32.2375 39.1562 32.0312 35.4562C31.025 35.1562 29.9625 35 28.8625 35H23.15H23.1438ZM42.4438 30.1062L34.9438 33.1063C34.375 33.3375 34 33.8875 34 34.5C34 38.4562 35.6187 45.05 42.425 47.8875C42.7937 48.0438 43.2125 48.0438 43.5812 47.8875C50.3812 45.05 52 38.4562 52 34.5C52 33.8875 51.625 33.3375 51.0563 33.1063L43.5562 30.1062C43.2 29.9625 42.8 29.9625 42.4438 30.1062ZM48.9625 35.5C48.7188 38.6688 47.2625 42.7938 43 44.8563V33.1187L48.9625 35.5Z",
    fill: "#30B0C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVictory);
export default __webpack_public_path__ + "static/media/victory.ad542809f50a7febd5b19ae93963856c.svg";
export { ForwardRef as ReactComponent };